export default __webpack_public_path__ + "static/media/pp-bg-ipad.3d705414.svg";